<template>
    <div id="slide_box" class="slide4">
        <div id="slide_content" :style="{background: siteCodeInfo[0].BACK_COLOR}">
            <div class="slide_block" id="slide4" :class="getShowClass()">
                <div class="slide_animate_block">
                    <div class="category" id="small">
                        <div class="bg" :style="{background: siteCodeInfo[0].BACK_COLOR}">
                            <div class="wrap01 wrap01_top">
                                <h2 class="stitle"><span v-html="siteCodeInfo[0].SMALL_WORD1_SP"></span></h2>
                                <p class="commonError" v-if="error.no_items">{{$msg.ERROR.MSG_1001}}</p>
                                <p class="commonError" v-else-if="error.no_items_without_large">{{$msg.ERROR.MSG_1002}}</p>
                                <p class="commonError" v-else-if="error.no_items_without_medium">{{$msg.ERROR.MSG_1003}}</p>
                                <div v-if="siteCodeInfo[0].PRICING_METHOD == 1" class="sp_spec_box">
                                    <div class="wrap03 comment_box">
                                        <p class="comment_txt_01" v-html="siteCodeInfo[0].SMALL_WORD3_SP"></p>
                                    </div>
                                    <div class="form_block_02">
                                        <div class="radio_box">
                                            <div class="form-Radio-02 radio_no"  :class="{radio_box_width: !(largeView || mediumView || displayFlg)}">
                                                <label :class="{pc_small: displayFlg, radio_label_width: !(largeView || mediumView || displayFlg)}">
                                                    <input type="radio" name="sp_spec_small_no_03" @click="setSmallItemUnit(1)" v-model="numOfSmallItemsTag" value="1">
                                                    <span class="input_txt" :style="{backgroundColor :numOfSmallItemsTag == '1'? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :numOfSmallItemsTag == '1'? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">1<span class="units">台</span></span>
                                                </label>
                                                <label :class="{pc_small: displayFlg, radio_label_width: !(largeView || mediumView || displayFlg)}">
                                                    <input type="radio" name="sp_spec_small_no_03" @click="setSmallItemUnit(2)" v-model="numOfSmallItemsTag" value="2">
                                                    <span class="input_txt" :style="{backgroundColor :numOfSmallItemsTag == '2'? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :numOfSmallItemsTag == '2'? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">2<span class="units">台以上</span></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="wrap01 wrap01_top">
                                <div class="sp_spec_box">
                                    <p v-if="siteCodeInfo[0].PRICING_METHOD == 1" class="comment_txt_02" v-html="siteCodeInfo[0].SMALL_WORD4_SP"></p>
                                    <p class="comment_txt_01" v-html="siteCodeInfo[0].SMALL_WORD2_SP"></p>
                                    <div class="form_block_02" id="sp_spec_small">
                                        <div class="radio_box">
                                            <div class="form-Radio-02 radio_no">
                                                <label :class="{sp_small: displayFlg}" v-if="largeView || mediumView">
                                                    <input type="radio" name="sp_spec_small_no_01" @click="setUnit(0)" v-model="smallTag" value="">
                                                    <span class="input_txt" :style="{backgroundColor :smallTag == ''? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :smallTag == ''? siteCodeInfo[0].SELECTED_BTN_COLOR:''}"><span v-html="firstChoiceContent"></span></span>
                                                </label>
                                                <label :class="{sp_small: displayFlg}" v-if="displayFlg">
                                                    <input type="radio" name="sp_spec_small_no_01" @click="setUnit(0)" v-model="smallTag" value="0"><span class="input_txt" :style="{backgroundColor :smallTag == '0'? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :smallTag == '0'? siteCodeInfo[0].SELECTED_BTN_COLOR:''}"><span class=" medium-include">中型に同梱</span></span>
                                                </label>
                                                <label :class="{sp_small: displayFlg, radio_label_width: !(largeView || mediumView || displayFlg)}">
                                                    <input type="radio" name="sp_spec_small_no_01" @click="setUnit(1)" v-model="smallTag" value="1">
                                                    <span class="input_txt" :style="{backgroundColor :smallTag == '1'? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :smallTag == '1'? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ startNum + 1 }}<span class="units">箱</span></span>
                                                </label>
                                                <label :class="{sp_small: displayFlg, radio_label_width: !(largeView || mediumView || displayFlg)}">
                                                    <input type="radio" name="sp_spec_small_no_01" @click="siteCodeInfo[0].BIZ_FLG == '1'?setDefault(item):createNumArray(startNum + 2)" v-model="smallTag" value="2">
                                                    <span class="input_txt" :style="{backgroundColor :smallTag == '2'? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :smallTag == '2'? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ startNum + 2 }}<span class="units">箱以上</span></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="no_box" v-if="item.quantityFlg && siteCodeInfo[0].BIZ_FLG == '1'">
                                            <div class="bg_box">
                                                <p class="title">箱数を入力</p>
                                                <div class="form-Radio-02 unit_box">
                                                    <input type="number" class="unit_box_input" @blur="unitInput(item, $event)" :value="item.quantity">
                                                    <span class="units">箱</span>
                                                    <p class="error" style="text-align:center" v-if="item.bizMaxUnitErrFlg">{{maxQuantityBiz + $msg.ERROR.MSG_0037}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="no_box" v-if="item.quantityFlg && siteCodeInfo[0].BIZ_FLG != '1'">
                                            <div class="bg_box">
                                                <p class="title">箱数を選択</p>
                                                <div class="form-Radio-02 label_box">
                                                    <label v-for="(num, index) in item.numArray" :key="num">
                                                        <input type="radio" name="sp_spec_small_no_02" v-model="item.quantity"
                                                        :value="index + 2">
                                                        <span class="input_txt" :style="{backgroundColor :item.quantity == num? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :item.quantity == num? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ num }}<span class="units">箱</span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.quantity" class="item_description_s1" v-html="displayItemDescription(item)"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="wrap01 wrap01_img">
                                <p><img :src="item.image" alt=""></p>
                            </div>
                            <div class="wrap01 wrap01_bottom">
                                <p class="next_page"><button type="button" class="form-Button-01 move_slide" :style="{backgroundColor : siteCodeInfo[0].NEXT_PAGE_BTN_COLOR}" data-toslide="slide5" @click="submitSmallItems">回収日時へ</button></p>
                                <div class="link_box">
                                    <p class="back_page"><span class="form-Button-back move_slide" data-toslide="slide3" @click="pageBack">戻る</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SmallItems from '../../js/SmallItemsForm'

export default {
    props: {
        siteCodeInfo: Array,
        siteCodeItem: Array
    },
    data() {
        return {
            item: {
                code: SmallItems.common.constant.CODE_SMALL,
                name: SmallItems.common.constant.NAME_SMALL,
                quantity: SmallItems.common.constant.QUANTITY_SMALL,
                maxQuantity: SmallItems.common.constant.MAXQUANTITY_SMALL,
                bizMaxUnitErrFlg: false,
                numArray: [],
                quantityFlg: false,
                fee: 0,
                fee_inc_tax: 0,
                image: SmallItems.common.constant.IMAGE_SMALL,
                smallItemQuantity : SmallItems.common.constant.QUANTITY_SMALL,
            },
            mediumCounts: 0,
            error: {
                no_items: false,
                no_items_without_large: false,
                no_items_without_medium: false,
            },
            smallTag: '',
            numOfSmallItemsTag: '',
            largeView: 0,
            mediumView: 0,
            maxQuantityBiz: SmallItems.common.constant.MAXQUANTITY_BIZ
        }
    },
    computed: {
        displayFlg: SmallItems.getDisplayFlg,
        startNum: SmallItems.getStartNum,
        firstChoiceContent: SmallItems.getFirstChoiceContent,
    },
    created() {
        SmallItems.inputRetention(this)
    },
    methods: {
        //台数選択のセレクトボックス表示
        createNumArray(start) {
            SmallItems.createNumArray(this, start)
        },
        setUnit(num) {
            SmallItems.setUnit(this, num)
        },
        setSmallItemUnit(num) {
            SmallItems.setSmallItemUnit(this, num)
        },
        submitSmallItems() {
            SmallItems.submitSmallItems(this, SmallItems.common.constant.SPECIFIC_DATETIME_PATH)
        },
        pageBack() {
            SmallItems.pageBack(this)
        },
        displayItemDescription(item) {
            return SmallItems.common.displayItemDescription(this, item)
        },
        unitInput(item, event) {
            SmallItems.unitInput(this, item, event)
        },
        setDefault(item) {
            SmallItems.setDefault(item)
        }
    }
}

</script>
